<template lang="html">
    <section class="create-sub-category">
        <h1>Create new sub-category for {{ getTranslate(action.category.terms.name) }} ({{ action.currentSections.name }})</h1>

        <div>
            <form>
                <div v-if="showMsg">
                    <p style="color: red"><strong>Probleme de creation d'une sous categorie</strong></p>
                </div>
                <div class="input-category" v-for="(lang, key) in getLangsValue" style="margin: 10px 0;">
                    <label
                        >Sub Category <span class="uppercase">{{ lang.label }}</span> :
                    </label>
                    <input type="text" class="textfield" v-model.trim="lang.value" :id="key" :name="lang.value" :key="key" />
                </div>
                <button class="btn" @click.prevent="addSubCategory(action, getLangsValue);">Create</button>
            </form>
        </div>
    </section>
</template>

<script lang="js">
import {mapActions, mapGetters} from 'vuex'
import httpService from '../../../../components/service'

export default {
    name: 'create-sub-category',
    props: [
        'action'
    ],
    mounted () {
    },
    data () {
        return {
            showMsg: false,
            getLangsValue: []
        }
    },
    created () {
        this.getLangsValue = this.getLangs.map(v => {
            return {
                'label': v.label,
                'value': ''
            }
        })
    },
    methods: {
        ...mapActions({
            listCatBySection: 'categories/listCatBySection'
        }),
        addSubCategory (value, cat) {
            let objValues = cat.map(v => {
                return {
                    'field': 'name',
                    'locale': v.label,
                    'content': v.value
                }
            })

            let firstObjValues = cat.map(v => {
                return {
                    'content': v.value
                }
            }).shift().content

            let obj = {
                "name": firstObjValues,
                "order": 0,
                "parent": {
                    "id": value.category.id
                },
                "brand": {
                    "id": this.getBrand.id
                },
                "section": {
                    "id": value.currentSections.id
                },
                "translations": objValues
            }
            httpService.post('/admin/categories', JSON.stringify(obj)).then(response => {
                if (response.success) {
                    this.listCatBySection(parseInt(value.currentSections.id))
                    this.showMsg = false
                    this.$root.$emit('bv::hide::modal', 'defaultModal')
                } else {
                    console.error('...+ERROR CreateSubCategory+....', response)
                    this.showMsg = true
                }

            })
        }
    },
    computed: {
        ...mapGetters({
            getLocale: 'i18n/getLocale',
            getLangs: 'i18n/getLangs',
            getBrand: 'brand/getBrand'
        })
    }
}
</script>

<style scoped lang="scss">
.create-sub-category {
}
</style>



// WEBPACK FOOTER //
// CreateSubCategory.vue?1ab28ba0